import { getProductFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import type { FlowConfigProps, StepConfigParams } from '@flows/configs/types'
import { BaseSchema_PetHealthV1GetsafeDe as schema } from '@flows/insurance/schemas'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import getPetHealthSteps from './steps'

const getPetHealthConfig = ({ clientHelpers, subFlow = SubFlow.PetHealth }: FlowConfigProps) => {
  const productKey = 'pet_health_v1_getsafe_de'
  const params: StepConfigParams = {
    clientHelpers,
    productKey,
    helperFunctions: generateGetFlowValueFunctions(productKey),
    subFlow,
  }
  return getProductFlowConfiguration(productKey, getPetHealthSteps(params), {
    constants: {
      SCHEMA: schema,
      FIRST_STEP_NAME: 'pet_name',
    },
    getInitialValues: () => {
      return {
        [productKey]: {
          productKey,
          configuration_parameters: {
            tariff_line: 'comfort',
            tariff_type: 'surgery_coverage',
            deductible_percentage: 20,
          },
        },
      }
    },
  })
}

export default getPetHealthConfig
